import React, { useMemo, Fragment } from 'react';

import { DayIndicator } from '@/components/DayIndicator';
import { Header } from '@/components/Header';
import { Spacer } from '@/components/Spacer';
import { useItineraryContext } from '@/context/ItineraryContext';
import { EnforcePageWidth } from '@/layout/PageLayout';
import { ItineraryBlockDayToDay } from '@/pages/DayToDay/components/ItineraryBlockDayToDay';
import { Logo, LogoPlacement } from '@/pages/DayToDay/styles';
import { sortItineraryBlockByDate } from '@/utils/sortItineraryBlockByDate';

export function DayToDay() {
  const itinerary = useItineraryContext();
  const itineraryBlocks = itinerary?.data?.ItineraryBlocks;
  const itineraryBlocksSorted = useMemo(
    () => itineraryBlocks && sortItineraryBlockByDate(itineraryBlocks),
    [itineraryBlocks],
  );
  const regularItineraryBlocks = useMemo(
    () => itineraryBlocksSorted?.filter((block) => block.type !== 'connection'),
    [itineraryBlocksSorted],
  );

  const headerImage = itinerary.data?.Destination.Content?.reduce((acc: string | null, content) => {
    if (content.type.toLowerCase() === 'main' && content?.RichContent) {
      const headerContent = content.RichContent.find((richContent) => richContent.subType?.toLowerCase() === 'header');
      return headerContent?.path || acc;
    }
    return acc;
  }, null);

  if (!itineraryBlocksSorted || !regularItineraryBlocks) {
    return null;
  }

  return (
    <LogoPlacement>
      <Logo src="/logo-white.png" alt="logo" />
      {headerImage && (
        <Header subTitle="Your journey from day to day" backgroundUrl={headerImage} hasNavigation={false} />
      )}
      <DayIndicator itineraryBlocks={regularItineraryBlocks} sticky />

      <EnforcePageWidth>
        <Spacer size="xl" />
        {itineraryBlocksSorted.map((block, index, blocks) => (
          <Fragment key={block.id}>
            <ItineraryBlockDayToDay
              itineraryBlock={block}
              index={index}
              key={block.id}
              isFirstBlock={index === 0}
              isLastBlock={index === itineraryBlocksSorted.length - 1}
              nextBlockTitle={block.type === 'connection' && blocks?.[index + 1]}
            />
          </Fragment>
        ))}
      </EnforcePageWidth>
    </LogoPlacement>
  );
}
